// extracted by mini-css-extract-plugin
export default {"setHoveredStyle":"mMSeJxeUTJSnVRrew30K","setBorder":"BaDQ8oGuuhIXKZuFlvCV","clickedStyleBg":"qjV4HFIPVhfQPvkNLjvd"};